<template>
  <div class="public-view min-vh-100 d-flex align-items-center py-5">
    <div class="container" data-aos="zoom-in-down">
      <div class="row justify-content-center">
        <div class="col-12 col-md-6 col-lg-5">
          <!-- Loading -->
          <div v-if="loading" class="text-center py-5 glass-card shadow">
            <div class="spinner-border text-success" role="status"></div>
            <p class="mt-3 fw-bold text-cafe">Consultando información...</p>
          </div>

          <!-- Producto encontrado -->
          <div
            v-else-if="producto"
            class="card shadow-2xl border-0 rounded-4 overflow-hidden"
          >
            <div class="header-arete d-flex align-items-center px-4 py-3">
              <img
                src="@/assets/img/Divisan/logo_divisan.png"
                alt="Divisan Logo"
                class="brand-logo-img me-3"
              />
              <div class="flex-grow-1 text-center">
                <h6 class="text-uppercase mb-1 small fw-bold text-verde-oscuro">
                  Identificador de Arete
                </h6>
                <h2 class="fw-black mb-0 text-cafe">{{ producto.codigo }}</h2>
              </div>
            </div>

            <div class="card-body p-4">
              <div class="info-group mb-4">
                <label class="label-custom">Descripción del Producto</label>
                <h4 class="fw-bold text-cafe">{{ producto.nombre }}</h4>
              </div>
              <div class="info-group">
                <label class="label-custom">Existencia en Sistema</label>
                <div class="stock-display p-3 rounded-3 text-center">
                  <span class="h1 fw-black text-verde-claro mb-0">
                    {{ producto.stock_sistema.toLocaleString() }}
                  </span>
                  <small class="d-block text-muted fw-bold">Unidades disponibles</small>
                </div>
              </div>
            </div>
          </div>

          <!-- No encontrado -->
          <div
            v-else
            class="text-center p-5 card shadow-lg border-0 rounded-4 glass-card"
          >
            <i
              class="bi bi-exclamation-triangle text-warning mb-3"
              style="font-size: 3.5rem"
            ></i>
            <h4 class="fw-black text-cafe">No encontrado</h4>
            <p class="text-muted">
              El código escaneado no coincide con ningún producto en el inventario actual.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { getProductoPorCodigo } from "@/utils/api_backend";

const route = useRoute();
const producto = ref(null);
const loading = ref(true);

async function fetchDetalle() {
  try {
    loading.value = true;
    producto.value = await getProductoPorCodigo(route.params.codigo);
  } catch (error) {
    console.error("Error al obtener detalle:", error);
  } finally {
    loading.value = false;
  }
}

onMounted(() => {
  fetchDetalle();
});
</script>

<style scoped>
.public-view {
  font-family: "Inter", sans-serif;
  background: linear-gradient(rgba(20, 30, 40, 0.5), rgba(20, 30, 40, 0.4)),
    url("@/assets/img/Divisan/img_2.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.fw-black {
  font-weight: 900;
}

.header-arete {
  background-color: var(--d-cream);
  border-bottom: 2px solid var(--d-green);
}

.brand-logo-img {
  height: 36px;
  width: auto;
  opacity: 0.9;
}

.card-body {
  background-color: #ffffff;
  color: #1f2933;
}

.label-custom {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--d-green-dark);
  letter-spacing: 0.08em;
}

.card-body h4 {
  color: #1f2933;
}

.stock-display {
  border: 2px dashed var(--d-green);
}
.stock-display span {
  color: var(--d-brown);
}

.text-cafe {
  color: var(--d-brown);
}
.text-verde-claro {
  color: var(--d-green);
}
.text-verde-oscuro {
  color: var(--d-green-dark);
}

.glass-card {
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(12px);
}

.shadow-2xl {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.45);
}
</style>
